const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/users.$user.znglist.$slug.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ZnglistFrontendSingleQuery, type Znglist_Frontend_Single_Query } from '@/graphql/queries/Znglist.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { znglistSchema } from './znglist.$slug';
export const Route = createFileRoute('/users/$user/znglist/$slug')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: znglistSchema,
  beforeLoad() {},
  loader({
    params
  }) {
    return loadQuery<Znglist_Frontend_Single_Query>(RelayEnvironment, ZnglistFrontendSingleQuery, {
      id: params.slug,
      idType: 'SLUG',
      isPersonalTemplate: true,
      userId: params.user,
      userIdType: 'SLUG'
    }, {
      fetchPolicy: 'store-or-network'
    });
  },
  onEnter: () => {
    useAppStore.getState().resetInertia();
    useAppStore.getState().setPageType('znglist');
    useAppStore.getState().setBarView('list');
  }
});